@if (modelLocator.menu.bottom) {
<ion-row slot="bottom" class="ion-hide-md-up" fixed>
  @for (item of menuFooter; track item.route) { @if (getCondition(item)) {
  <ion-col (click)="touchGoToRoute(item)">
    @if (item.icon.type === 'img') {
    <ion-img [src]="item.icon.src"></ion-img>
    } @else {
    <ion-icon [src]="item.icon.src"></ion-icon>
    } @if (item.tag) {
    <img class="tag_novo" [src]="item.tag" />
    }

    <ion-label>{{ item.label }}</ion-label>
  </ion-col>
  } }
</ion-row>
}
